'use client'

import styled from 'styled-components'

export const ContentStyled = styled.div`
  padding: var(--spacing-padding-large) var(--spacing-padding-large)
    var(--spacing-padding-large);
  flex-grow: 1;
`
